//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ModalLogin',
  data() {
    return {
      submitting: false,
      error: "",
      email: "",
      password: "",
      remember_me: false,
      login_casino: false,
      sports: [],
      showPassword: false
    }
  },
  async mounted() {
    
  },
  beforeUnmount: function () {

  },
  methods: {
     beforeOpen (event) {
      this.error = ""
      window.dispatchEvent(new Event('resize'));
    },
    close() {
       this.$modal.hide('modal-login')
    },
    async submit() {
      this.error = ""
      this.submitting = true
      try {
        let result = await this.$auth().post('/api/common/login', {
            login: this.email,
            password: this.password,
            remember_me: +this.remember_me
        })
        let data = _.get(result, 'data')
        if( _.get(data, 'result') ) {

          let login_jwt = _.get(data, 'jwt')
          localStorage.setItem('jwt', login_jwt); //save the jwt
          let domain = '.' + this.$config.DOMAIN;
          this.$cookies.set('jwt', login_jwt, {
            path: '/',
            domain: domain,
            secure: true
          })
          localStorage.setItem('login_token', _.get(data, 'userInfo.login_token')); //save the jwt
          let user_info = this.format_user(_.get(data, 'userInfo'));
          // console.log('result user_info', user_info)
          user_info.balance = user_info.balance*100
          user_info.zendesk_jwt = _.get(data, 'zendesk_jwt')
          window.loginToken = _.get(data, 'userInfo.login_token')
          this.$store.commit('auth/setLoginToken', _.get(data, 'userInfo.login_token'))
          this.$store.commit('auth/setJwt', login_jwt)
          this.$store.commit('auth/storeUser', user_info)
          await this.getBalance();
          // await this.updateSession();
          //this.$router.push(this.localePath({ path: '/' }))
          this.$gtm.push(data.aff)          
          this.$modal.hide('modal-login')

          window.zE("messenger", "logoutUser")
          window.zE("messenger", "loginUser", function (callback) {
            callback(user_info.zendesk_jwt)
          });

          if (this.login_casino) {
            await this.$popup.crossLogin(this.$store.state.auth.loginToken + '-' + (user_info?.id || ''));
          }

          // check require verify
          if (user_info.require_verify !== false) {
            this.$modal.show('modal-require-verify')
          } else {
            this.$modal.hide('modal-require-verify')
          }
          
          // check terms          
          if (user_info.ask_for_terms) {
            this.$modal.show('modal-accept-terms')
          }
          // check privacy
          if (user_info.ask_for_privacy) {
            this.$modal.show('modal-accept-privacy')
          }          
          // check status
          if (user_info.status_cnj === 'PV') {
            this.$modal.show('modal-players-pv')
          }

        } else {
          if (_.get(data, 'reason') === "password_compromised") {
            this.$modal.hide('modal-login')
            this.$nextTick(() => {
              this.$modal.show('modal-forgot-password',{is_password_compromised:true})
            })
          } else {
            if(_.isArray(_.get(data, 'message'))) {
              this.error = _.get(data, 'message.0')
            } else {
              this.error = _.get(data, 'message')
            }
          }
        }
      } catch(e) {
        let data = _.get(e, 'response.data')
        if (_.get(data, 'reason') === "password_compromised") {
          this.$modal.hide('modal-login')
          this.$nextTick(() => {
            this.$modal.show('modal-forgot-password',{is_password_compromised:true})
          })
        } else {
          if(_.isArray(_.get(data, 'message'))) {
            this.error = _.get(data, 'message.0')
          } else {
            this.error = _.get(data, 'message')
          }
          if(!data) {
            this.error = _.get(e, 'message')
          }
        }
      }
      this.submitting = false
    },
    togglePassword() {
      this.showPassword = !this.showPassword

      if(this.showPassword) {
        this.$refs.passwordInput.type = 'text'
      } else {
        this.$refs.passwordInput.type = 'password'
      }
    },
  }
}
